<template>
  <div class="forgetpassword my-2">
    <span>ลืมรหัสผ่าน</span>
    <input
      v-model="phone_number"
      type="text"
      class="form-control mt-2"
      placeholder="กรอกเบอร์โทรศัพท์"
    />
    <mdb-btn
      class="btn-login font16"
      v-if="!isloading"
      block
      @click="checknumberphone()"
      >ยืนยัน</mdb-btn
    >
    <mdb-btn class="btn-login font16" block disabled v-else> ยืนยัน</mdb-btn>
  </div>
</template>

<script>
// eslint-disable-next-line no-unused-vars

const jwt = require("jsonwebtoken");
export default {
  components: {},
  data() {
    return {
      phone_number: null,
      isloading: false,
    };
  },
  methods: {
    checknumberphone() {
      const checkPhone = /^[^a-z][0-9]+$/;
      if (checkPhone.test(this.phone_number)) {
        if (this.phone_number.length === 10) {
          if (this.phone_number[0] === "0") {
            if (
              this.phone_number[1] === "8" ||
              this.phone_number[1] === "9" ||
              this.phone_number[1] === "6"
            ) {
              this.funForgetpassword();
            } else {
              this.phone_number = null;
              this.$swal({
                text:
                  "เบอร์โทรศัพท์ต้องขึ้นต้นด้วย 06 หรือ 08 หรือ 09 เท่านั้น",
                icon: "warning",
                timer: 5000,
                showConfirmButton: true,
                allowOutsideClick: false,
                allowEscapeKey: false,
              });
            }
          } else {
            this.phone_number = null;
            this.$swal({
              text: "เบอร์โทรศัพท์ต้องขึ้นต้นด้วย 0 เท่านั้น",
              icon: "warning",
              timer: 5000,
              showConfirmButton: true,
              allowOutsideClick: false,
              allowEscapeKey: false,
            });
          }
        } else {
          this.phone_number = null;
          this.$swal({
            text: "กรุณากรอกเบอร์โทรศัพท์ให้ครบ 10 หลัก",
            icon: "warning",
            timer: 5000,
            showConfirmButton: true,
            allowOutsideClick: false,
            allowEscapeKey: false,
          });
        }
        //   this.$swal({
        //     text: "test",
        //     icon: "warning",
        //     timer: 5000,
        //     showConfirmButton: true,
        //     allowOutsideClick: false,
        //     allowEscapeKey: false,
        //   });
      } else {
        this.phone_number = null;
        this.$swal({
          text: "เบอร์โทรของคุณกรุณากรอกแค่ตัวเลข",
          icon: "warning",
          timer: 5000,
          showConfirmButton: true,
          allowOutsideClick: false,
          allowEscapeKey: false,
        });
      }
    },
    funForgetpassword() {
      if (this.phone_number === null || this.phone_number === "") {
        this.$swal({
          text: "กรุณากรอกข้อมูล",
          icon: "warning",
          timer: 5000,
          showConfirmButton: true,
          allowOutsideClick: false,
          allowEscapeKey: false,
        });
      } else {
        let payload = {
          phone_number: this.phone_number,
        };
        // console.log(payload);
        this.isloading = true;
        let token = jwt.sign(payload, this.$keypayload, {
          expiresIn: "60000s",
        });
        this.$axios
          .post("/forgetPassword?type=SMS", { token: token })
          .then((response) => {
            this.isloading = false;

            if (response.data.code === 1) {
              this.$swal({
                text: response.data.msg,
                icon: "warning",
                timer: 5000,
                showConfirmButton: true,
                allowOutsideClick: false,
                allowEscapeKey: false,
              });
            } else {
              this.$swal({
                text: response.data.msg,
                icon: "warning",
                timer: 5000,
                showConfirmButton: true,
                allowOutsideClick: false,
                allowEscapeKey: false,
              });
            }
          })
          .catch((error) => {
            this.isloading = false;
            console.log(error);
          });
      }
    },
  },
};
</script>

<style>
.Login {
  background: #131313;
  height: 100vh;
  width: 100%;
  position: relative;
  overflow-x: hidden;
}
.btn-login {
  color: #ffffff;
  background-color: #f5904b !important;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25),
    inset 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 18px !important;
  padding: 10px 15px 10px 15px;
  margin-top: 30px !important;
}
.btn-register {
  color: #000000;
  background-color: #f2f2f2 !important;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25),
    inset 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 18px !important;
  padding: 10px 15px 10px 15px;
}
</style>
